import _ from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Menu } from 'semantic-ui-react';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { uniqueKey } from '../../common/keys';
import { sortingHelpers } from '../../common/sorting';
import { propHelpers } from '../../common/tester';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import WrapperVertCols from '../../wrappers/WrapperVertCols';

const SearchMenu = (props) => {

  const { searchData } = props

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state } = states

  // papsContext  
  const { view, viewKey } = paps_state ?? {}

  // dataContext 
  let storageItem = 'alpha-item-'
  storageItem += viewKey ? view + '-' + viewKey : view

  const _menuContainerId = 'alpha-menu' // + view

  // local state  
  const [currentItem, setCurrentItem] = useState({})
  const [currentItems, setCurrentItems] = useState({})
  const [showNext, setShowNext] = useState()
  const [snc, setSnc] = useState({})
  const [sidebar, setSidebar] = useState({})
  const [currentStates, setCurrentStates] = useState([])

  console.log('currentItem', currentItem)

  const _isVert = true

  if (snc && snc.className && snc.className.indexOf('alpha-float') < 0) {
    snc.className += ' alpha-float abs-side'
    snc.className += ' hidden'
  }

  const scrollableDivRef = useRef(null);

  useEffect(() => {
    const menu = document.getElementById('alpha-menu');

    if (!menu) return;

    const htm = (e) => {
      e.preventDefault();
    };

    menu.addEventListener('touchmove', htm, { passive: false });

    return () => {
      menu.removeEventListener('touchmove', htm);
    };
  }, []);

  // useEffect(() => {
  //   const htm = (e) => {
  //     // Check if the touch event target is within the scrollable div 
  //     if (e.target.closest('.menu-alphabet') && e.target.closest('.menu-alphabet').id === 'alpha-menu') {
  //       e.preventDefault();
  //     }
  //   };

  //   document.addEventListener('touchmove', htm, { passive: false });

  //   return () => {
  //     document.removeEventListener('touchmove', htm);
  //   };
  // }, [scrollableDivRef]);

  useEffect(() => {
    const data = searchData
    const _sidebar = { _0: Object.keys(data) }
    const _currentSidebar = { _0: data }
    setSidebar(_sidebar)
    setCurrentStates(_currentSidebar)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [states]);

  useEffect(() => {
    const _sidebar = { ...sidebar }
    const nextIndex = currentItem.sbIndex + 1
    const deleteIndex = currentItem.sbIndex + 2
    const _sbIndex = '_' + currentItem.sbIndex
    if (currentItem && currentStates[_sbIndex] && currentStates[_sbIndex][currentItem.itemValue]) {
      const item = currentStates[_sbIndex][currentItem.itemValue]
      let skis;
      if (_.isObject(item)) {
        skis = item ? Object.keys(item) : []
      } else if (_.isArray(item)) {
        skis = item
      } else if (_.isBoolean(item)) {
        skis = item.toString()
      } else {
        skis = item
      }

      _sidebar['_' + nextIndex] = skis
      currentStates['_' + nextIndex] = item

      for (let i = 10; i >= 0; i--) {
        if (i >= deleteIndex) {
          delete _sidebar['_' + i]
          delete currentStates['_' + i]
        }
      }

      setSidebar(_sidebar)
      setCurrentStates(currentStates)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentItem]);


  const handleUpdateAlpha = (itemValue, sbIndex) => {
    if (showNext && (itemValue !== currentItem.itemValue)) {
      const _currentItems = { ...currentItems }
      const _sbIndex = '_' + sbIndex
      _currentItems[_sbIndex] = itemValue
      setCurrentItem({ itemValue, sbIndex });
      setCurrentItems(_currentItems);
    }
  }

  const handleTouchMove = (event, sbIndex) => {
    const touchedItem = document.elementFromPoint(
      event.touches[0].clientX,
      event.touches[0].clientY
    );
    if (touchedItem && touchedItem.attributes && touchedItem.attributes['itemval'] && touchedItem.attributes['itemval'].value) {
      const itemValue = touchedItem.attributes['itemval'].value
      if (itemValue !== currentItem.itemValue) {
        setCurrentItem({ sbIndex, sbIndex })
      }
    }
  }

  const handleSetAlphaItem = (sbIndex) => {
    setShowNext(false)
  }

  const handleShowSecond = (e, sbIndex) => {
    if (e) { handleTouchMove(e, sbIndex) }
    setShowNext(true)
  }

  const nameInfo = (item, itemKey) => {
    const { key, name, lastName, firstName, startDate, startTime } = item ?? {}
    const _name = lastName && firstName ? lastName + ', ' + firstName : name
    const _date = startDate ? startDate + ' - ' + startTime : null
    if (_name) {
      return <div>
        <div>{_name}</div>
        <div>{key}</div>
        {_date && <div>{_date}</div>}
      </div>
    } else if (itemKey) {
      return <div>
        <div>{item}</div>
        <div>{itemKey}</div>
      </div>
    }
  }

  const menuItem = (item, index, sbIndex, itemKey) => {

    const { key } = item ?? {}
    const _key = key ? key : item

    const _sbIndex = '_' + sbIndex
    const _selected = currentItems && currentItems[_sbIndex] && (currentItems[_sbIndex] === _key)

    return <Menu.Item
      id={'am_' + index}
      itemval={_key}
      touchtype={'mi'}
      name={_key}
      key={uniqueKey('abm', _key)}
      active={_selected}

      onTouchStart={() => { _isVert && handleUpdateAlpha(_key, sbIndex) }}

      onMouseMove={() => { _isVert && handleUpdateAlpha(_key, sbIndex) }}
      onTouchMove={(e) => { _isVert && handleTouchMove(e, sbIndex) }}

      // end
      onMouseUp={(e) => { _isVert && handleSetAlphaItem(_key, sbIndex) }}
      onTouchEnd={() => { _isVert && handleSetAlphaItem(_key, sbIndex) }}
    >
      {nameInfo(item, itemKey)}
    </Menu.Item>
  }

  const items = (keys, sbIndex, csis) => {
    if (_.isArray(keys)) {
      if (propHelpers.isComplexObject(csis)) {
        const _sorted = sortingHelpers.sortObjectWithKeys(csis, ['name', 'lastName', 'firstName'])
        const mis = _sorted.map((svk, index) => {
          return menuItem(svk, index, sbIndex)
        })
        return mis
      } else {
        const mis = []
        _.forEach(csis, (item, itemKey) => {
          mis.push(menuItem(item, 0, sbIndex, itemKey))
        })
        return mis
      }
    }
  }

  let cn = snc.className

  if (cn) {
    cn += showNext ? ' ' : ' dead'
  }

  const menu = (keys, _keyy, csis) => <Menu
    className='menu-quick'
    key={'sb' + _keyy}
    ref={scrollableDivRef}
    id={_menuContainerId}
    onMouseDown={(e) => { _isVert && handleShowSecond() }}
    onTouchStart={(e) => { _isVert && handleShowSecond(e) }}
    onTouchMove={(e) => { _isVert && handleTouchMove(e) }}
    inverted
    borderless
    vertical={_isVert ? true : false}
    compact={_isVert ? true : null}
    style={snc.style}
  >
    {keys && items(keys, _keyy, csis)}
  </Menu >

  const menuItems = () => {
    const itemList = Array.from({ length: 4 }, (_, index) => index);
    return itemList.map((item) => (
      <Wrapper
        header={'Level ' + item + 1}
        content={menu(sidebar['_' + item], item, currentStates['_' + item])}
        wrapperType={wrapperTypes.paddedHeader}
      />
    ))
  }

  const content = () => <WrapperVertCols mvc={4}>
    {menuItems()}
  </WrapperVertCols>

  // search-float
  return content()

}

export default SearchMenu
